export const DEFAULT_ALLOWED_DOMAINS = "qadar.ai,junus.ai,firstier.ai";

export function resolveAllowedDomains(raw) {
  const value = typeof raw === "string" && raw.trim() !== "" ? raw : DEFAULT_ALLOWED_DOMAINS;
  return value
    .toLowerCase()
    .split(/[,\s]+/)
    .filter(Boolean);
}
